import { OrderApiClient } from '@fourthwall/services/dist/OrderApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useOrderRefundQuery = createQueryHook(OrderApiClient.getOrderRefund, {
  queryKey: ['orderRefund'],
})
